// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","276":"GuestLazyComponent"}[chunkId] + "." + {"46":"319448c3c3918e97f06c","276":"c8024beb363dd64ef606"}[chunkId] + ".js";
};